import { getSupportWidgetMode } from "../supportWidget";
import { useIntercom } from "./useIntercom";
import { useAuth } from "./useAuth";

interface SupportWidgetControls {
  hideWidget: () => void;
  showWidget: () => void;
  shiftWidget: () => void;
  unshiftWidget: () => void;
}

const noop = () => {};

export const useSupportWidget = (): SupportWidgetControls => {
  const mode = getSupportWidgetMode();
  const { isAdmin } = useAuth();
  const { hideIntercom, showIntercom, shiftIntercom, unshiftIntercom } =
    useIntercom();

  // Intercom is the support widget for regular users, even when showme is
  // enabled (showme is admin-only for prototyping).
  if (mode === "intercom" || (mode === "showme" && !isAdmin)) {
    return {
      hideWidget: hideIntercom,
      showWidget: showIntercom,
      shiftWidget: shiftIntercom,
      unshiftWidget: unshiftIntercom,
    };
  }

  return {
    hideWidget: noop,
    showWidget: noop,
    shiftWidget: noop,
    unshiftWidget: noop,
  };
};
